import { imageStyles } from "@insite/content-library/Widgets/Basic/Image";
import { contentSpacingStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(imageStyles, {
    wrapper: {
        css: css`
            ${contentSpacingStyles()}

            img {
                display: block;
                width: 100%;
            }
        `,
    },
    image: {
        css: css`
            background-color: transparent;
        `,
    },
});
